// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participants-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px 8px;
  border: 1px solid #cccccc;
  border-radius: 2px;
  color: #4d4d4d;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 4px 10px;
  border: 1px solid;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  color: #4d4d4d;
}

.status-pill-active {
  background-color: #e8f4fb;
  border-color: #007bc0;
  color: #007bc0;
}

.status-pill-pending_configuration {
  background-color: #f2f2f2;
  border-color: #cccccc;
}

.groupActions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.groupActions > * {
  flex-shrink: 0;
}

.groupActionButton {
  padding: 6px 8px;
  border: 2px solid #007bc0;
  background: transparent;
  color: #007bc0;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  border-radius: 2px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.groupActionButton:hover {
  background-color: #d1e4ff;
}

.deleteGroupWarning {
  margin: 12px 0 0;
  color: #4d4d4d;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  font-family: 'Bosch Sans', sans-serif;
}

.groupDetailsIcon {
  width: 20px;
  height: auto;
  filter: brightness(0) saturate(100%) invert(31%) sepia(99%) saturate(1047%)
    hue-rotate(170deg) brightness(91%) contrast(101%);
}
`, "",{"version":3,"sources":["webpack://./src/pages/GruposResponsabilidade/GruposResponsabilidade.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;qDACmD;AACrD","sourcesContent":[".participants-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 8px;\n  border: 1px solid #cccccc;\n  border-radius: 2px;\n  color: #4d4d4d;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: center;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 4px 10px;\n  border: 1px solid;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-align: center;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  color: #4d4d4d;\n}\n\n.status-pill-active {\n  background-color: #e8f4fb;\n  border-color: #007bc0;\n  color: #007bc0;\n}\n\n.status-pill-pending_configuration {\n  background-color: #f2f2f2;\n  border-color: #cccccc;\n}\n\n.groupActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  width: 100%;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.groupActions > * {\n  flex-shrink: 0;\n}\n\n.groupActionButton {\n  padding: 6px 8px;\n  border: 2px solid #007bc0;\n  background: transparent;\n  color: #007bc0;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n  border-radius: 2px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.groupActionButton:hover {\n  background-color: #d1e4ff;\n}\n\n.deleteGroupWarning {\n  margin: 12px 0 0;\n  color: #4d4d4d;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  font-family: 'Bosch Sans', sans-serif;\n}\n\n.groupDetailsIcon {\n  width: 20px;\n  height: auto;\n  filter: brightness(0) saturate(100%) invert(31%) sepia(99%) saturate(1047%)\n    hue-rotate(170deg) brightness(91%) contrast(101%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
